<template>
  <div class="certs">
    <van-nav-bar
      title="结清证明"
      left-arrow
      safe-area-inset-top
      @click-left="$router.go(-1)"
    />

    <div v-if="list.length" class="list">
      <div
        v-for="item in list"
        :key="item.contractId"
        class="item"
        @click="$router.push(`/settle-cert/${item.contractId}`)"
      >
        <div class="main">
          <div class="name">{{ item.productName || '贷款合同' }}</div>
          <div class="sub">业务编号 {{ item.contractNo }}</div>
          <div class="sub">借款金额 ¥{{ Number(item.principal || 0).toFixed(2) }} · 结清日 {{ item.settleDate }}</div>
        </div>
        <van-tag type="success">已结清</van-tag>
      </div>
    </div>
    <div v-else class="empty">
      <p>暂无结清证明</p>
      <p class="tip">贷款全部还清后可在此查看并下载结清证明</p>
    </div>
  </div>
</template>

<script>
import { settlementCerts } from '@/api/request'

export default {
  name: 'SettleCertList',
  data() {
    return { list: [] }
  },
  async mounted() {
    try {
      const res = await settlementCerts()
      this.list = (res.data && res.data.list) || []
    } catch (e) {
      this.list = []
    }
  }
}
</script>

<style lang="less" scoped>
.certs {
  min-height: 100%;
  background: #f5f5f5;
}
.van-nav-bar {
  background-image: linear-gradient(to right, #6aa8f5, #3d8aef);
  /deep/ .van-nav-bar__title,
  /deep/ .van-icon {
    color: #fff;
  }
}
.list {
  padding: 12px;
}
.item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.04);
}
.name {
  font-size: 15px;
  font-weight: 700;
  color: #333;
}
.sub {
  margin-top: 6px;
  font-size: 12px;
  color: #888;
}
.empty {
  text-align: center;
  padding: 80px 20px;
  color: #999;
  .tip {
    margin-top: 8px;
    font-size: 12px;
  }
}
</style>
